import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ArrowLeft, Location } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { httpReauest } from "../utils/httpRequest";

const AddAddress = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      title: "",
      address: "",
      detail: "",
      phone: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required(t("add_address_validation_title")),
      address: Yup.string().required(t("add_address_validation_address")),
      detail: Yup.string(),
      phone: Yup.string()
        .matches(/^(?:7|9)\d{7}$/, t("login_invalid_phone"))
        .required(t("login_required_phone")),
    }),
    onSubmit: async (values) => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) return;
      try {
        await httpReauest(
          "POST",
          "/user/add/address",
          { ...values, userId: user._id },
          { "x-access-token": user.token }
        );
        navigate(-1);
      } catch (error) {
        console.error("خطا در ذخیره آدرس", error);
      }
    },
  });

  return (
    <div className="min-h-screen flex flex-col px-4">
      <div className="flex justify-end py-4">
        <button onClick={() => navigate(-1)}>
          <ArrowLeft />
        </button>
      </div>

      <div className="flex justify-between items-start px-3 py-2 bg-white shadow rounded-[8px]">
        <div className="flex gap-2 items-center">
          <Location size={22} />
          {t("add_address_title")}
        </div>
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="px-3 py-2 bg-white shadow rounded-[8px] mt-4"
      >
        <div className="flex flex-col gap-4">
          {/* عنوان آدرس */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("add_address_label_title")}
            </label>
            <input
              type="text"
              name="title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
              className="w-full border border-gray-300 rounded px-3 py-2"
              placeholder={t("add_address_placeholder_title")}
            />
            {formik.touched.title && formik.errors.title && (
              <div className="text-red-500 text-xs mt-1">
                {formik.errors.title}
              </div>
            )}
          </div>

          {/* نشانی */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("add_address_label_address")}
            </label>
            <input
              type="text"
              name="address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.address}
              className="w-full border border-gray-300 rounded px-3 py-2"
              placeholder={t("add_address_placeholder_address")}
            />
            {formik.touched.address && formik.errors.address && (
              <div className="text-red-500 text-xs mt-1">
                {formik.errors.address}
              </div>
            )}
          </div>

          {/* جزئیات */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("add_address_label_detail")}
            </label>
            <textarea
              name="detail"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.detail}
              className="w-full border border-gray-300 rounded px-3 py-2"
              rows="3"
              placeholder={t("add_address_placeholder_detail")}
            />
          </div>

          {/* شماره تماس */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("add_address_label_phone")}
            </label>
            <input
              type="tel"
              name="phone"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.phone}
              className="w-full border border-gray-300 rounded px-3 py-2"
              placeholder={t("login_phone_placeholder")}
            />
            {formik.touched.phone && formik.errors.phone && (
              <div className="text-red-500 text-xs mt-1">
                {formik.errors.phone}
              </div>
            )}
          </div>

          {/* دکمه ذخیره */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-[var(--primary)] text-white px-4 py-2 rounded hover:bg-[var(--hoverprimary)] transition"
            >
              {t("add_address_button_submit")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddAddress;
